import { AirshipActions } from './AirshipActions';
import { AirshipAnalytics } from './AirshipAnalytics';
import { AirshipChannel } from './AirshipChannel';
import { AirshipContact } from './AirshipContact';
import { AirshipFeatureFlagManager } from './AirshipFeatureFlagManager';
import { AirshipInApp } from './AirshipInApp';
import { AirshipLocale } from './AirshipLocale';
import { AirshipMessageCenter } from './AirshipMessageCenter';
import { AirshipPreferenceCenter } from './AirshipPreferenceCenter';
import { AirshipPrivacyManager } from './AirshipPrivacyManager';
import { AirshipPush } from './AirshipPush';
import { EventType } from './EventType';
import { AirshipLiveActivityManager } from './AirshipLiveActivityManager';
import { AirshipLiveUpdateManager } from './AirshipLiveUpdateManager';
/**
 * Airship
 */
export class AirshipRoot {
    constructor(plugin) {
        this.plugin = plugin;
        this.actions = new AirshipActions(plugin);
        this.analytics = new AirshipAnalytics(plugin);
        this.channel = new AirshipChannel(plugin);
        this.contact = new AirshipContact(plugin);
        this.inApp = new AirshipInApp(plugin);
        this.locale = new AirshipLocale(plugin);
        this.messageCenter = new AirshipMessageCenter(plugin);
        this.preferenceCenter = new AirshipPreferenceCenter(plugin);
        this.privacyManager = new AirshipPrivacyManager(plugin);
        this.push = new AirshipPush(plugin);
        this.featureFlagManager = new AirshipFeatureFlagManager(plugin);
        this.iOS = new AirshipRootIOS(plugin);
        this.android = new AirshipRootAndroid(plugin);
    }
    /**
     * Calls takeOff. If Airship is already configured for
     * the app session, the new config will be applied on the next
     * app init.
     * @param config The config.
     * @returns A promise with the result. `true` if airship is ready.
     */
    takeOff(config) {
        return this.plugin.perform('takeOff', config);
    }
    /**
     * Checks if Airship is ready.
     * @returns A promise with the result.
     */
    isFlying() {
        return this.plugin.perform('isFlying');
    }
    /**
     * Adds a deep link listener.
     */
    onDeepLink(listener) {
        return this.plugin.addListener(EventType.DeepLink, listener);
    }
}
export class AirshipRootIOS {
    constructor(plugin) {
        this.liveActivityManager = new AirshipLiveActivityManager(plugin);
    }
}
export class AirshipRootAndroid {
    constructor(plugin) {
        this.liveUpdateManager = new AirshipLiveUpdateManager(plugin);
    }
}
//# sourceMappingURL=AirshipRoot.js.map